// /////////////
// マウントポイント
// /////////////

import { createPinia } from "pinia";
import { createApp } from "vue";
import type { VueProps } from "@/shared/types";
import InteractForm from "./InteractForm.vue";

// グローバル変数からプロップを取得
const mountId = "interact-form";

const mountElement = document.getElementById(mountId);

if (!mountElement) {
	console.error(
		"[InteractForm Debug] Mount element not found! Available elements:",
		Array.from(document.querySelectorAll("[id]")).map((el) => el.id),
	);
}

const props =
	window.vueProps && window.vueProps[mountId] ? window.vueProps[mountId] : {};

// プロップを渡してアプリケーションを作成
const app = createApp(InteractForm, props);
app.use(createPinia());

try {
	app.mount(`#${mountId}`); // WordPressテンプレート側のマウントポイントに対応
} catch (error) {
	console.error("[InteractForm Debug] Failed to mount application:", error);
}
